import React, { useState, useEffect } from 'react';
import inspectionStorage from '../services/inspectionStorage';
import syncManager from '../services/syncManager';

const constatations = [
  "1- Présence de traces d'échauffement anormal d'une canalisation et /ou d'un matériel électrique",
  "2- Absence de moyens de protection des transformateurs (HT/BT,BT/HT,HT/HT)",
  "3- Absence ou inadaptation des dispositifs de protection contre les surintensités",
  "4- Dysfonctionnement des dispositifs différentiels à courant résiduel",
  "5- Présence de poussière déposée ou de substances de nature à provoquer un danger dans les armoires électrique",
  "6- Inadéquation des matériels ou des canalisations électriques dans les locaux à risques d'incendie et/ou zones à risques d'explosion",
  "7- Défauts de continuité du conducteur de protection dans les locaux à risques d'incendie et/ou zones à risques d'explosion",
  "8- Existence de locaux à risques d'incendie et/ou à risques d'explosion pour lesquelles l'installation ne répond à aucune des deux conditions suivantes : Présence, bonne adéquation, bon fonctionnement du ou des dispositifs assurant la signalisation ou la coupure au 1er défaut d'isolement, Protection des circuits alimentant ces locaux ou emplacements par dispositifs à courant différentiel résiduel de seuil réglage à 300mA."
];

const styles = {
  container: { minHeight: '100vh', background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)', paddingBottom: '100px' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', background: 'white', borderBottom: '1px solid #e2e8f0', position: 'sticky', top: 0, zIndex: 100 },
  backBtn: { background: 'none', border: 'none', fontSize: '16px', color: '#3b82f6', cursor: 'pointer', padding: '8px 12px', borderRadius: '8px' },
  content: { padding: '16px', display: 'flex', flexDirection: 'column', gap: '16px' },
  card: { background: 'white', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', overflow: 'hidden' },
  cardHeader: { padding: '14px 16px', background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)', color: 'white' },
  cardHeaderRed: { padding: '14px 16px', background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)', color: 'white' },
  cardHeaderPurple: { padding: '14px 16px', background: 'linear-gradient(135deg, #a855f7 0%, #9333ea 100%)', color: 'white' },
  cardHeaderGreen: { padding: '14px 16px', background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)', color: 'white' },
  cardHeaderOrange: { padding: '14px 16px', background: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)', color: 'white' },
  cardHeaderIndigo: { padding: '14px 16px', background: 'linear-gradient(135deg, #6366f1 0%, #4338ca 100%)', color: 'white' },
  cardBody: { padding: '16px' },
  formGroup: { marginBottom: '16px' },
  label: { display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: 500, color: '#334155' },
  input: { width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', background: 'white', boxSizing: 'border-box' },
  textarea: { width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', background: 'white', boxSizing: 'border-box', minHeight: '80px', resize: 'vertical' },
  radioGroup: { display: 'flex', gap: '16px', flexWrap: 'wrap' },
  radioOption: { display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' },
  radioInput: { width: '18px', height: '18px', cursor: 'pointer' },
  checkboxRow: { display: 'flex', alignItems: 'center', gap: '10px', padding: '12px', background: '#f8fafc', borderRadius: '8px', marginBottom: '8px' },
  checkbox: { width: '20px', height: '20px', cursor: 'pointer' },
  
  constatationItem: { padding: '16px', borderBottom: '1px solid #e2e8f0', background: 'white' },
  constatationItemLinked: { padding: '16px', borderBottom: '1px solid #e2e8f0', background: '#fef3c7' },
  constatationText: { fontSize: '13px', color: '#1e293b', marginBottom: '12px', lineHeight: 1.5 },
  constatationOptions: { display: 'flex', flexWrap: 'wrap', gap: '8px' },
  optionBtn: { padding: '8px 12px', borderRadius: '20px', border: '2px solid #e2e8f0', background: 'white', fontSize: '11px', fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s' },
  optionBtnActive: { borderColor: '#22c55e', background: '#dcfce7', color: '#166534' },
  optionBtnDanger: { borderColor: '#ef4444', background: '#fee2e2', color: '#991b1b' },
  optionBtnSoNv: { borderColor: '#6366f1', background: '#e0e7ff', color: '#3730a3' },
  optionBtnPrev: { borderColor: '#f97316', background: '#ffedd5', color: '#9a3412' },
  selectSmall: { padding: '6px 10px', borderRadius: '6px', border: '1px solid #d1d5db', fontSize: '12px', marginLeft: '8px' },
  linkedBadge: { display: 'inline-block', padding: '4px 8px', background: '#f97316', color: 'white', borderRadius: '12px', fontSize: '10px', fontWeight: 600, marginRight: '4px', marginTop: '8px' },
  
  conclusionBox: { padding: '16px', borderRadius: '12px', marginBottom: '16px' },
  conclusionDanger: { background: '#fee2e2', border: '2px solid #ef4444' },
  conclusionSafe: { background: '#dcfce7', border: '2px solid #22c55e' },
  
  actions: { position: 'fixed', bottom: 0, left: 0, right: 0, display: 'flex', gap: '12px', padding: '16px', background: 'white', borderTop: '1px solid #e2e8f0', boxShadow: '0 -4px 12px rgba(0,0,0,0.1)' },
  btnSecondary: { flex: 1, padding: '14px', borderRadius: '12px', fontSize: '15px', fontWeight: 600, cursor: 'pointer', background: 'white', border: '2px solid #e2e8f0', color: '#64748b' },
  btnPrimary: { flex: 1, padding: '14px', borderRadius: '12px', fontSize: '15px', fontWeight: 600, cursor: 'pointer', background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)', border: 'none', color: 'white' }
};

function Etape15Q18({ mission, onBack, onSave }) {
  const [formData, setFormData] = useState({
    establishment_buildings: 'Ensemble de l\'établissement',
    has_fire_risk_designation: false,
    has_explosion_protection_doc: 'so',
    constatations_table: constatations.map(() => ({ status: 'ok' })),
    events_modifications: '',
    events_incidents: '',
    events_safety_measures: '',
    non_compliance_points: '',
    general_comments: '',
    q19_delivered: false,
    has_photovoltaic: false,
    ground_connection_schema: '',
    conclusion_risk: false,
    present_person_name: '',
    present_person_function: '',
    signature_location: ''
  });
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    loadSavedData();
  }, []);

  useEffect(() => {
    const hasDanger = formData.constatations_table.some(
      item => item?.status === 'danger' || item?.status === 'danger_prev'
    );
    if (hasDanger !== formData.conclusion_risk) {
      setFormData(prev => ({ ...prev, conclusion_risk: hasDanger }));
    }
  }, [formData.constatations_table]);

  useEffect(() => {
    const hasLinkedObs = formData.constatations_table.some(
      item => item?.obs_numeros && item.obs_numeros.length > 0
    );
    const autoText = 'Voir liste des observations ci-dessous';
    
    if (hasLinkedObs && formData.non_compliance_points !== autoText) {
      setFormData(prev => ({ ...prev, non_compliance_points: autoText }));
    } else if (!hasLinkedObs && formData.non_compliance_points === autoText) {
      setFormData(prev => ({ ...prev, non_compliance_points: '' }));
    }
  }, [formData.constatations_table]);

  const loadSavedData = async () => {
    try {
      const saved = await inspectionStorage.getStep(mission.id, 'rapport_q18_data');
      if (saved) {
        setFormData(prev => ({ ...prev, ...saved }));
      }
    } catch (error) {
      console.error('Erreur chargement Q18:', error);
    }
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleConstatationChange = (index, status) => {
    const newTable = [...formData.constatations_table];
    const currentItem = { ...(newTable[index] || { status: 'ok' }) };
    currentItem.status = status;
    
    if (status === 'so_nv' && !currentItem.so_nv_value) {
      currentItem.so_nv_value = 'SO';
    }
    
    if (currentItem.obs_numeros) {
      delete currentItem.obs_numeros;
    }
    
    newTable[index] = currentItem;
    handleChange('constatations_table', newTable);
  };

  const handleSoNvChange = (index, value) => {
    const newTable = [...formData.constatations_table];
    newTable[index] = { ...(newTable[index] || { status: 'ok' }), so_nv_value: value };
    handleChange('constatations_table', newTable);
  };

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await inspectionStorage.saveStep(mission.id, 'rapport_q18_data', formData);
      await syncManager.syncStep(mission.id, 'rapport_q18_data', formData);
      
      if (onSave) onSave(formData);
      alert('Annexe Q18 sauvegardée !');
      onBack();
    } catch (error) {
      console.error('Erreur sauvegarde Q18:', error);
      alert('Erreur lors de la sauvegarde');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>← Retour</button>
        <div style={{ textAlign: 'center' }}>
          <h1 style={{ margin: 0, fontSize: '18px', fontWeight: 700, color: '#1e293b' }}>Annexe Q18</h1>
          <p style={{ margin: '4px 0 0', fontSize: '13px', color: '#64748b' }}>Risques incendie / explosion</p>
        </div>
        <div style={{ width: '60px' }}></div>
      </div>

      <div style={styles.content}>
        {/* Informations complémentaires */}
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <h2 style={{ margin: 0, fontSize: '15px', fontWeight: 700 }}>ℹ️ Informations complémentaires</h2>
          </div>
          <div style={styles.cardBody}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Bâtiment(s) concerné(s)</label>
              <input
                type="text"
                style={styles.input}
                value={formData.establishment_buildings}
                onChange={(e) => handleChange('establishment_buildings', e.target.value)}
              />
            </div>
            
            <div style={styles.formGroup}>
              <label style={styles.label}>Désignation des locaux à risque d'incendie</label>
              <div style={styles.radioGroup}>
                <label style={styles.radioOption}>
                  <input
                    type="radio"
                    style={styles.radioInput}
                    checked={formData.has_fire_risk_designation === true}
                    onChange={() => handleChange('has_fire_risk_designation', true)}
                  />
                  <span>Oui</span>
                </label>
                <label style={styles.radioOption}>
                  <input
                    type="radio"
                    style={styles.radioInput}
                    checked={formData.has_fire_risk_designation === false}
                    onChange={() => handleChange('has_fire_risk_designation', false)}
                  />
                  <span>Non</span>
                </label>
              </div>
            </div>
            
            <div style={styles.formGroup}>
              <label style={styles.label}>Document relatif à la protection contre les explosions</label>
              <div style={styles.radioGroup}>
                <label style={styles.radioOption}>
                  <input
                    type="radio"
                    style={styles.radioInput}
                    checked={formData.has_explosion_protection_doc === 'oui'}
                    onChange={() => handleChange('has_explosion_protection_doc', 'oui')}
                  />
                  <span>Oui</span>
                </label>
                <label style={styles.radioOption}>
                  <input
                    type="radio"
                    style={styles.radioInput}
                    checked={formData.has_explosion_protection_doc === 'non'}
                    onChange={() => handleChange('has_explosion_protection_doc', 'non')}
                  />
                  <span>Non</span>
                </label>
                <label style={styles.radioOption}>
                  <input
                    type="radio"
                    style={styles.radioInput}
                    checked={formData.has_explosion_protection_doc === 'so'}
                    onChange={() => handleChange('has_explosion_protection_doc', 'so')}
                  />
                  <span>Sans Objet</span>
                </label>
              </div>
            </div>
          </div>
        </div>

        {/* Constatations */}
        <div style={styles.card}>
          <div style={styles.cardHeaderRed}>
            <h2 style={{ margin: 0, fontSize: '15px', fontWeight: 700 }}>🛡️ Constatations</h2>
          </div>
          <div style={{ padding: 0 }}>
            {constatations.map((text, index) => {
              const itemData = formData.constatations_table[index] || { status: 'ok' };
              const currentStatus = itemData.status || 'ok';
              const hasLinkedObs = itemData.obs_numeros && itemData.obs_numeros.length > 0;
              
              return (
                <div 
                  key={index} 
                  style={hasLinkedObs ? styles.constatationItemLinked : styles.constatationItem}
                >
                  <div style={styles.constatationText}>{text}</div>
                  
                  {hasLinkedObs && (
                    <div style={{ marginBottom: '10px' }}>
                      <span style={{ fontSize: '11px', color: '#92400e', fontWeight: 600 }}>Obs. liées: </span>
                      {itemData.obs_numeros.map(num => (
                        <span key={num} style={styles.linkedBadge}>N°{num}</span>
                      ))}
                    </div>
                  )}
                  
                  <div style={styles.constatationOptions}>
                    <button
                      style={{
                        ...styles.optionBtn,
                        ...(currentStatus === 'ok' ? styles.optionBtnActive : {})
                      }}
                      onClick={() => handleConstatationChange(index, 'ok')}
                      disabled={hasLinkedObs}
                    >
                      ✅ Absence de danger
                    </button>
                    <button
                      style={{
                        ...styles.optionBtn,
                        ...(currentStatus === 'danger' ? styles.optionBtnDanger : {})
                      }}
                      onClick={() => handleConstatationChange(index, 'danger')}
                      disabled={hasLinkedObs}
                    >
                      ⚠️ Danger (1ère fois)
                    </button>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <button
                        style={{
                          ...styles.optionBtn,
                          ...(currentStatus === 'so_nv' ? styles.optionBtnSoNv : {})
                        }}
                        onClick={() => handleConstatationChange(index, 'so_nv')}
                        disabled={hasLinkedObs}
                      >
                        📋 SO/NV
                      </button>
                      {currentStatus === 'so_nv' && (
                        <select
                          style={styles.selectSmall}
                          value={itemData.so_nv_value || 'SO'}
                          onChange={(e) => handleSoNvChange(index, e.target.value)}
                          disabled={hasLinkedObs}
                        >
                          <option value="SO">SO</option>
                          <option value="NV">NV</option>
                        </select>
                      )}
                    </div>
                    <button
                      style={{
                        ...styles.optionBtn,
                        ...(currentStatus === 'danger_prev' ? styles.optionBtnPrev : {})
                      }}
                      onClick={() => handleConstatationChange(index, 'danger_prev')}
                      disabled={hasLinkedObs}
                    >
                      🔄 Danger déjà signalé
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Événements déclarés */}
        <div style={styles.card}>
          <div style={styles.cardHeaderPurple}>
            <h2 style={{ margin: 0, fontSize: '15px', fontWeight: 700 }}>📖 Événements déclarés</h2>
          </div>
          <div style={styles.cardBody}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Modification de l'installation</label>
              <textarea
                style={styles.textarea}
                value={formData.events_modifications}
                onChange={(e) => handleChange('events_modifications', e.target.value)}
                placeholder="Décrire les modifications..."
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Incidents</label>
              <textarea
                style={styles.textarea}
                value={formData.events_incidents}
                onChange={(e) => handleChange('events_incidents', e.target.value)}
                placeholder="Décrire les incidents..."
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Dispositions pour améliorer la sécurité</label>
              <textarea
                style={styles.textarea}
                value={formData.events_safety_measures}
                onChange={(e) => handleChange('events_safety_measures', e.target.value)}
                placeholder="Décrire les mesures..."
              />
            </div>
          </div>
        </div>

        {/* Points de non-conformité */}
        <div style={styles.card}>
          <div style={styles.cardHeaderOrange}>
            <h2 style={{ margin: 0, fontSize: '15px', fontWeight: 700 }}>✏️ Points de non-conformité</h2>
          </div>
          <div style={styles.cardBody}>
            <div style={styles.formGroup}>
              <textarea
                style={{ ...styles.textarea, background: '#f8fafc' }}
                value={formData.non_compliance_points}
                disabled
                placeholder="Rempli automatiquement si observations liées"
              />
              <p style={{ fontSize: '11px', color: '#64748b', marginTop: '6px' }}>
                Ce champ est automatiquement rempli si des observations sont liées depuis l'étape 11.
              </p>
            </div>
          </div>
        </div>

        {/* Commentaires */}
        <div style={styles.card}>
          <div style={styles.cardHeaderGreen}>
            <h2 style={{ margin: 0, fontSize: '15px', fontWeight: 700 }}>💬 Commentaires</h2>
          </div>
          <div style={styles.cardBody}>
            <div style={styles.formGroup}>
              <textarea
                style={styles.textarea}
                value={formData.general_comments}
                onChange={(e) => handleChange('general_comments', e.target.value)}
                placeholder="Commentaires généraux..."
              />
            </div>
            
            <div style={styles.checkboxRow}>
              <input
                type="checkbox"
                style={styles.checkbox}
                checked={formData.q19_delivered || false}
                onChange={(e) => handleChange('q19_delivered', e.target.checked)}
              />
              <label style={{ fontSize: '14px', color: '#1e293b' }}>Compte rendu Q19 délivré</label>
            </div>
            
            <div style={styles.checkboxRow}>
              <input
                type="checkbox"
                style={styles.checkbox}
                checked={formData.has_photovoltaic || false}
                onChange={(e) => handleChange('has_photovoltaic', e.target.checked)}
              />
              <label style={{ fontSize: '14px', color: '#1e293b' }}>Présence d'une installation photovoltaïque</label>
            </div>
            
            <div style={{ ...styles.formGroup, marginTop: '16px', marginBottom: 0 }}>
              <label style={styles.label}>Schéma de liaison à la terre de l'installation BT</label>
              <input
                type="text"
                style={styles.input}
                value={formData.ground_connection_schema}
                onChange={(e) => handleChange('ground_connection_schema', e.target.value)}
                placeholder="Ex: TT, TN-S, IT..."
              />
            </div>
          </div>
        </div>

        {/* Conclusion */}
        <div style={styles.card}>
          <div style={styles.cardHeaderIndigo}>
            <h2 style={{ margin: 0, fontSize: '15px', fontWeight: 700 }}>📄 Conclusion</h2>
          </div>
          <div style={styles.cardBody}>
            <div style={{
              ...styles.conclusionBox,
              ...(formData.conclusion_risk ? styles.conclusionDanger : styles.conclusionSafe)
            }}>
              <div style={{ fontWeight: 700, fontSize: '14px', marginBottom: '8px', color: formData.conclusion_risk ? '#991b1b' : '#166534' }}>
                {formData.conclusion_risk 
                  ? '⚠️ L\'installation PEUT entraîner des risques d\'incendie et d\'explosion'
                  : '✅ L\'installation NE PEUT PAS entraîner des risques d\'incendie et d\'explosion'
                }
              </div>
              <p style={{ fontSize: '11px', color: '#64748b', margin: 0 }}>
                Déterminé automatiquement par le tableau des constatations.
              </p>
            </div>
            
            <div style={styles.formGroup}>
              <label style={styles.label}>Vérification effectuée en présence de</label>
              <input
                type="text"
                style={styles.input}
                value={formData.present_person_name}
                onChange={(e) => handleChange('present_person_name', e.target.value)}
                placeholder="Nom de la personne"
              />
            </div>
            
            <div style={styles.formGroup}>
              <label style={styles.label}>Fonction</label>
              <input
                type="text"
                style={styles.input}
                value={formData.present_person_function}
                onChange={(e) => handleChange('present_person_function', e.target.value)}
                placeholder="Fonction de la personne"
              />
            </div>
            
            <div style={{ ...styles.formGroup, marginBottom: 0 }}>
              <label style={styles.label}>Fait à</label>
              <input
                type="text"
                style={styles.input}
                value={formData.signature_location}
                onChange={(e) => handleChange('signature_location', e.target.value)}
                placeholder="Lieu de signature"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Actions */}
      <div style={styles.actions}>
        <button style={styles.btnSecondary} onClick={onBack} disabled={isSaving}>
          Annuler
        </button>
        <button 
          style={{ ...styles.btnPrimary, opacity: isSaving ? 0.6 : 1 }} 
          onClick={handleSave} 
          disabled={isSaving}
        >
          {isSaving ? '💾 Sauvegarde...' : '💾 Sauvegarder'}
        </button>
      </div>
    </div>
  );
}

export default Etape15Q18;